import { PostHog } from "posthog-js";

import { NewAccount } from "containers/SellerCreateAccount/SellSideCreateAccount";
import {
  makeSimpleGetRequest,
  makeSimpleHeadRequest,
  makeSimplePostRequest,
} from "lib/axios";
import { getCookie } from "lib/helpers";
import {
  BASE_SERVER_URL,
  DIRECTORY_URL,
  ORDERBOOK_URL,
} from "services/constants";
import { ACCOUNT_CREATED } from "services/postHog/constants";

import { PlaidResponse, User, UserEmailExists, UserProfile } from "./types";

const AUTH_URL = `${BASE_SERVER_URL}/accounts/api`;
const SELLER_LOGIN_URL = "/accounts/SellerLogin/";

export const getCurrentUser = () =>
  makeSimpleGetRequest<User>(`${DIRECTORY_URL}/CurrentUser/`);

export const getCSRFToken = () =>
  makeSimpleGetRequest(`${DIRECTORY_URL}/CSRF/`);

export const completeSellerAccount = async (payload: any): Promise<User> =>
  makeSimplePostRequest<User>(
    `${DIRECTORY_URL}/CompleteSellerAccount/`,
    JSON.stringify(payload),
    [201],
  );

export const getProfileData = async (): Promise<UserProfile> =>
  makeSimpleGetRequest<UserProfile>(`${DIRECTORY_URL}/user-profile/`);

export const updateProfile = async (payload: any): Promise<void> =>
  makeSimplePostRequest<void>(
    `${DIRECTORY_URL}/user-profile/`,
    JSON.stringify(payload),
    [200],
  );

export const releaseHijack = () => {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = `${BASE_SERVER_URL}/hijack/release/`;

  const csrfInput = document.createElement("input");
  csrfInput.type = "hidden";
  csrfInput.name = "csrfmiddlewaretoken";
  csrfInput.value = getCookie("csrftoken") || "";
  form.appendChild(csrfInput);

  document.body.appendChild(form);
  form.submit();
};

export const enableSMSNotifications = async (payload: {
  phone_number: string;
}) => {
  makeSimplePostRequest(
    `${AUTH_URL}/sms-notifications/`,
    JSON.stringify(payload),
    [204],
  );
};

export const getPlaidLink = async (): Promise<string> =>
  (
    await makeSimpleGetRequest<{ link_token: string }>(
      `${ORDERBOOK_URL}/plaid_link_token/`,
    )
  ).link_token;

// This method accept a Plaid temporary access token from the Plaid web auth dialog
// It converts it to a permanent token
// Then it checks the bank account balanaces for the minimum required balance
// And returns verified status Y/N
export const verifyInvestorWithPlaid = async (
  token: string,
): Promise<PlaidResponse> =>
  makeSimplePostRequest(
    `${ORDERBOOK_URL}/plaid_link_token/`,
    JSON.stringify({
      public_token: token,
    }),
    [200],
  );

export const getEmailExists = (email: string): Promise<UserEmailExists> =>
  makeSimpleHeadRequest<UserEmailExists>(
    `${DIRECTORY_URL}/EmailExists/${email}/`,
  );

export const createNewSeller = async (
  account: NewAccount,
  posthog: PostHog,
): Promise<User> => {
  const response = await makeSimplePostRequest<User>(
    `${DIRECTORY_URL}/NewSeller/`,
    JSON.stringify(account),
    [201],
  );
  posthog?.capture(ACCOUNT_CREATED, {
    source: "worth",
    isSeller: response.isSeller,
  });
  return response;
};

export const sellerLogin = (user: {
  email: string;
  password: string;
}): Promise<User> =>
  makeSimplePostRequest<User>(`${SELLER_LOGIN_URL}`, JSON.stringify(user), [
    200,
  ]);
